import {
  RoommateNumberID,
  SuitableForNumberID,
} from '@kamernet/core/ApiClient/Kamernet';

export const SuitableForNumberLabels: Record<SuitableForNumberID, string> = {
  [SuitableForNumberID.Empty]: '',
  [SuitableForNumberID.OnePerson]: '1',
  [SuitableForNumberID.TwoPersons]: '2',
  [SuitableForNumberID.ThreePersons]: '3',
  [SuitableForNumberID.FourPersons]: '4',
  [SuitableForNumberID.FivePersons]: '5',
  [SuitableForNumberID.MoreThanFivePersons]: '5+',
};

export const RoommateNumberLabels: Record<RoommateNumberID, string> = {
  [RoommateNumberID.Empty]: '0',
  [RoommateNumberID.None]: '0',
  [RoommateNumberID.One]: '1',
  [RoommateNumberID.Two]: '2',
  [RoommateNumberID.Three]: '3',
  [RoommateNumberID.Four]: '4',
  [RoommateNumberID.Five]: '5',
  [RoommateNumberID.Six]: '6',
  [RoommateNumberID.Seven]: '7',
  [RoommateNumberID.Eight]: '8',
  [RoommateNumberID.MoreThanEight]: '8+',
  [RoommateNumberID.NotRelevant]: '-',
};
